import React from 'react';
import { View } from 'react-native';
import { WaterfallFlowProps } from './WaterfallFlow.types';
import { styles } from './WaterfallFlow.styles';
import { splitArray } from '@/utils';
export const WaterfallFlow: React.FC<WaterfallFlowProps> = ({
    data,
    renderItem,
    marginHorizontal = 10,
    marginLeft = 5,
    marginRight = 5,
}) => {
    const [leftData, rightData] = splitArray(data);

    return (
        <View style={[styles.card_content, { marginHorizontal }]}>
            <View style={[styles.card_left, { marginRight }]}>
                {leftData.map((item, index) => (
                    <React.Fragment key={index}>{renderItem(item)}</React.Fragment>
                ))}
            </View>
            <View style={[styles.card_right, { marginLeft }]}>
                {rightData.map((item, index) => (
                    <React.Fragment key={index}>{renderItem(item)}</React.Fragment>
                ))}
            </View>
        </View>
    );
};

export default WaterfallFlow;

